export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/john-towner-7f9d96cdc593d82f631d0938b7b0dc57.jpg";